<script>
  import getTranslation from '../../../utilities/getTranslation';

  export let subscription, showOffer, productId;

  const getProductOfferTerms = (productId) => {
    const product = subscription.products.find((p) => p.metadataId === productId);
    return getTranslation(product.informationKeys, 'pricing.offer.terms', '');
  };
  const hasTerms = showOffer && getProductOfferTerms(productId) !== '';
</script>

<style lang="scss">
  @use './styles/sharedStyles' as *;
  @use '../index' as *;

  .offer-terms {
    max-width: 32rem;
    padding: spacing(2) spacing(2);
    color: #5c5c5c;
    font-size: 1.4rem;
    line-height: 16.8px;
  }

  .with-offer-terms {
    padding-block-end: spacing(4);
  }
</style>

<div class="offer-terms" class:with-offer-terms={hasTerms}>
  {#if hasTerms}
    <span>{getProductOfferTerms(productId)}</span>
  {/if}
</div>
